import Immutable from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = Immutable.List();

const cycleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CYCLES_SUCCESS: {
      return Immutable.List(action.cycles);
    }
    default: {
      return state;
    }
  }
};

export default cycleReducer;



// WEBPACK FOOTER //
// ./src/reducers/cycleReducer.js